export default __webpack_public_path__ + "static/media/play.411809a5.svg";